import { type ApiResult, type BaseParams, links, Request } from '@app/client';
import { type DiscoverResponse } from '@app/client/common/structs/nbe/discoverResponseTypes';

import { apiReturnResults } from '../../../ApiFactory';

export async function getDiscoverCollections(params: BaseParams): Promise<ApiResult<DiscoverResponse>> {
    return Request.getRequest<DiscoverResponse>({
        ...params,
        target: links.nbe.discover,
        apiSettingsType: 'yatNode',
    });
}

export const callGetDiscoverCollections = (params: BaseParams) =>
    apiReturnResults<DiscoverResponse>(getDiscoverCollections, params);
